// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2T7RY","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__VFU8n"};